import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-cream-light pt-12 pb-20 px-4 md:px-6 overflow-hidden" data-id="element-99">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-100">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-block bg-teal-light text-teal-dark px-4 py-1.5 rounded-full text-sm font-medium tracking-wide mb-8 border border-teal/10" data-id="element-101">
          Para mujeres 35+ en peri/menopausia
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-warm-dark leading-tight mb-6" data-id="element-102">
          Tu barriga no es "grasa": <br className="hidden md:block" data-id="element-103" />
          <span className="text-teal italic" data-id="element-104">es un cuerpo en defensa.</span>
        </motion.h1>

        {/* Subheadline */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-xl md:text-2xl text-warm-gray mb-12 max-w-2xl" data-id="element-105">
          El reset de 21 días para dejar de inflamarte sin vivir a dieta.
        </motion.h2>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="w-full max-w-lg mb-12 relative" data-id="element-106">
          <div className="absolute inset-0 bg-teal/5 blur-3xl rounded-full transform scale-110 -z-10" data-id="element-107"></div>
          <img src="https://cdn.magicpatterns.com/uploads/4Mum7Qw3v6dksu3JCu6coL/menopausia_sin_castigo.png" alt="Menopausia Sin Castigo en tablet y móvil" className="w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-108" />
        </motion.div>

        {/* Emotional Lead */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-left max-w-2xl bg-white/50 backdrop-blur-sm p-8 rounded-2xl border border-cream-dark/10 shadow-sm mb-12" data-id="element-109">
          <p className="text-lg text-warm-gray mb-4" data-id="element-110">
            Te juro que hay un tipo de cansancio que no se arregla con "échale
            ganas".
          </p>
          <p className="text-lg text-warm-gray mb-4" data-id="element-111">
            Es ese cansancio donde haces lo correcto: comes "limpio", caminas,
            intentas controlar porciones… y aun así te levantas inflamada, te
            aprieta la ropa al mediodía, y por la noche tu mente se va a:
          </p>
          <p className="text-lg font-medium text-teal-dark italic mb-4" data-id="element-112">
            "¿Qué me está pasando… si antes sí podía?"
          </p>
          <p className="text-lg text-warm-gray mb-4" data-id="element-113">
            Y lo peor no es el espejo. Lo peor es la conversación interna:
            "Seguro estoy fallando otra vez."
          </p>
          <p className="text-lg font-semibold text-warm-dark" data-id="element-114">
            No estás fallando. Estás usando herramientas viejas para un cuerpo
            que ahora juega con reglas nuevas.
          </p>
        </motion.div>

        {/* CTA */}
        <motion.a href="#pricing" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="bg-teal hover:bg-teal-dark text-cream-light text-lg md:text-xl font-semibold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all flex items-center gap-2 group cursor-pointer" data-id="element-115">
          Quiero el Reset de 21 días
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-116" />
        </motion.a>
      </div>
    </section>;
}